// regnskapsforer-nav-messages translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'r1n.denied.title': 'El espacio del despacho es solo para los miembros del despacho contable',
  'r1n.denied.body': 'Los clientes trabajan en el espacio de su propia empresa y no pueden abrir la vista general de clientes, la conciliación ni el control del despacho.',
  'r1n.denied.exit': 'A mi contabilidad',
});
